/*
 * Project: LegalPlace assistant
 * File: src/redux/actions/load_contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

// loading axios library
// import { axios } from 'axios';
// get the load contract actuion logic

// this is used if we could'nt use any URL
// import { preview_1 } from '../../logic/test/previewData';
// import { contract_json } from '../../logic/test/sas';
// import { contract } from '../../logic/test/contrat_de_travail';

import { isNull } from 'util';
import { SET_DOCUMENT_ID } from './document_state';

import { loadingWizard, unloadingWizard, loadingPricing, unloadingPricing } from './loading';
import {
  loadOVC, autosaveLoadOVC,
} from './load_ovc';
import {
  LpError,
} from '../../errors/error';
import {
  lpSetError,
} from './lperrors';
import lpevents from '../../tracking/lpevents';
import {
  setFullWidth,
} from './contract';
import {
  _lp,
} from '../../logic/wording';
import 'whatwg-fetch';
import lpApp from '../../app/lp_app';
import { autosave, checkAutosave } from '../../logic/autosave';
import { reorderViews } from '../../logic/re_index';
import { buildCheckout } from '../actions/checkout_operations'
import {AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID} from '../../constants/subscription_constant'
import { getContract, getCheckout, getContractAndOVC, getContractOrder } from '../../manager/apiManager'
import { updateMailFromInput } from './account_settings';

import ConditionsEvo from '../../logic/condition_evo'
import { updateSectionsIfConditions } from '../reducers/contract';
import Cookies from 'universal-cookie'
import jwt from "jsonwebtoken";

const cookies = new Cookies()
export const SET_FULL_WIDTH = 'SET_FULL_WIDTH';


// load usig axios
// Copied from web
function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}


const lpAllTree = {};
const lpAllIndexVar = {};

function lpExplore(id, babies) {
  if (babies) {
    babies.forEach((idx) => {
      lpAllTree[idx] = id;
      // get children
      const me = lpApp.references.getOption(idx);
      if (me.children && me.children.length > 0) {
        lpExplore(idx, me.children);
      }
    });
  }
}

function lpExploreSections() {
  if (lpApp.references.options && Object.keys(lpApp.references.options).length > 0) {
    Object.keys(lpApp.references.options).forEach((idx) => {
      const now = lpApp.references.getOption(idx);
      lpExplore(parseInt(idx, 10), now.children);
      // explore variables
      if (now.variables) {
        now.variables.forEach((jdx) => {
          lpAllIndexVar[jdx] = parseInt(idx, 10);
        });
      }
    });
  }

  // Object.keys(sections).map((idx) => {
  //     lpExplore(-1 * parseInt(idx) ,sections[idx].options)
  // });
}

function fetchAndInitContractWithOVC (contractPermalink, uniqid, dispatch, getState, callback = () => {}, isCheckout = false) {
  dispatch({type: 'IS_LOADING'});
  dispatch(loadingWizard());
  dispatch(loadingPricing())
  getContractAndOVC(contractPermalink, uniqid)
  .then(async response => {
    const contract = response.data;
    // To redirect to wizardx if instance
    if (contract.appType === "wizardx" && !isCheckout) {
      const abCookie = cookies.get('X-Source')
      if (abCookie && abCookie.split('/').length > 1 && abCookie.split('/')[1] === 'wizard') {
        cookies.set('X-Source', `${abCookie.split('/')[0]}/wizardxs/wizard-lp`,{path: '/', encode: (value) => value})
        window.onbeforeunload = () => {};
        document.location.reload(true)
      }
    }
      lpApp.mutex.setMutex('links', false);
      // tell everyone that the document is not empty
      dispatch({type: 'NO_EMPTY'});
      // extract the preview indexes
      dispatch({
        type: 'PREVIEW_INDEX_',
        val: contract.views_wrapper,
      });
      lpApp.references.addViewsRefernce(contract.views_wrapper);
      if (contract.contract_architecture.params && contract.contract_architecture.params.varsExtraction) {
        lpApp.references.addSlackNotification(
          contract.contract_architecture.params.varsExtraction
        );
      }
      lpApp.references.addCustomizationsReference(contract.model_params);
      lpApp.setSubscription(contract.model_params.enable_subscription)
      lpApp.setIsPaidSession(contract.is_paid_session)
      lpApp.setType(contract.type, contract.contract_meta_id)
      lpApp.setPayed(contract.is_paid)

      if (lpApp.isPayed) {
        const order = await getContractOrder(lpApp.contractUniqid).then(response => response.data ? response.data.order : response.data)
        const isLoggedIn = !!cookies.get('token')
        const decodedToken = jwt.decode(cookies.get('token')) || {}
        const { role } = decodedToken
        const isNotAuthorised = !isLoggedIn || role === 'GUEST'
        const hasQuizzStatus = ['analyzing', 'valid'].includes(order.quizz_status)
        if (isNotAuthorised && hasQuizzStatus) {
          window.onbeforeunload = null
          window.onunload = null
          window.location.href = `${process.env.REACT_APP_BO_FORMALITES}/download/${lpApp.contractUniqid}`
        }
      }
      lpApp.setContractMetaId(contract.contract_meta_id)
      .then( () => {
      lpApp.setContractUniqid(uniqid)
      dispatch({ type: SET_DOCUMENT_ID, doc: uniqid });
      lpApp.setDisableIntro(contract.data_intro ? contract.data_intro === 'disabled' : false)
      if (contract.support_phone) {
        lpApp.setSupportPhone(contract.support_phone.txt)
      }
      // ======================================================
      // FIXME: construct a better one here
      lpApp.references.docs_wrappers = contract.docs_wrapper;

      if (!isCheckout) {


        dispatch({type: 'CREATE_CONTRACT',contract});
        for (let i = 0; i < getState().contract.total_sections; i += 1) window.lp[i] = false;
        // finish the loading phase
        lpExploreSections();
        // window.lp_grandpa = lpAllTree;
        lpApp.indexes.updateGrandpa(lpAllTree);
        // window.lp_var_gran = lpAllIndexVar;
        lpApp.indexes.grandpa_vars.buildGrandpaVariables(lpAllIndexVar);
        lpApp.references.addMandatpryOptions(lpApp.references.options);
        lpApp.references.addMandatoryVariables(lpApp.references.variables);
        // Initiating ConditionsEvo right after loading model
        ConditionsEvo.init();

        // Updating sections conditions after initiating ConditionsEvo
        updateSectionsIfConditions();

        // do initializatio  of static texts into the preview component
        // dispatch(initOutPut())
        if (
          contract.contract_architecture
          && contract.contract_architecture.params
          && contract.contract_architecture.params.fullWidth
        ) {
          dispatch(setFullWidth(contract.contract_architecture.params.fullWidth));
          lpApp.setFullWidth(contract.contract_architecture.params.fullWidth);
        } else {
          dispatch(setFullWidth(false));
          lpApp.setFullWidth(false);
        }

        if ((contract.contract_architecture.is_two_steps)) {
          // dispatch(setFullWidth(true))
          // lpApp.setFullWidth(true);
        } else if (contract.contract_architecture
            && contract.contract_architecture.params
            && contract.contract_architecture.params.fullWidth
        ) {
          dispatch(setFullWidth(contract.contract_architecture.params.fullWidth));
          lpApp.setFullWidth(contract.contract_architecture.params.fullWidth);
        } else {
          dispatch(setFullWidth(false));
          lpApp.setFullWidth(false);
        }

        // I don't know why I put this here wallah
        // dispatch({type: 'NO_EMPTY'});
        caluclateConditionDependecies();
        lpApp.indexes.updateDependencies();
        reorderViews(getState().views);
        // initialize the whole thing
        window.lp = {};


        window.addEventListener('beforeunload', autosave);

        // let url = new URL(window.location.href);
        const autosaveParam = (() => {
          // $_GET JS
          const $_GET_PARTS = window.location.search.substr(1).split('&');
          const $_GET = {};
          for (let i = 0; i < $_GET_PARTS.length; i += 1) {
            const temp = $_GET_PARTS[i].split('=');
            $_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
          }
          if ($_GET.autosaved) return true;
          return null;
        })();

        // Checking autosave
        const autosaveOVC = checkAutosave();

        if (window.contract_id !== '' || (lpApp.continuity && lpApp.continuity.continue)) {
          if (lpApp.isPrerender) {
            dispatch(loadOVC(contract.ovc));
          } else if (lpApp.continuity.continue) dispatch(loadOVC(contract.ovc));
          else dispatch(loadOVC(contract.ovc));

          dispatch({
            type: 'SET_SECTION_ID',
            id: 0,
          });
          const currentEvent = {};
          currentEvent['Document version:'] = getState().contract.version;
          lpevents.register({
            Contract: getState().contract.name,
          });
          lpevents.track('Continue contract', currentEvent);
        } else if (!isNull(autosaveParam) && autosaveOVC !== false) {
          window.autosave = !!(autosaveOVC);

          // autosave check
          dispatch(autosaveLoadOVC(autosaveOVC.data));

          const sectionId = autosaveOVC.info.section - 1;

          dispatch({
            type: 'SET_SECTION_ID',
            id: sectionId,
          });

          lpApp.mutex.setMutex('links', true);
        } else {
          const currentEvent = {
            'LpApp': 'React'
          };
          currentEvent['Document version:'] = getState().contract.version;
          lpevents.register({
            Contract: getState().contract.name,
          });
          lpevents.track('Create new contract', currentEvent);
          dispatch({
            type: 'NOT_LOADING',
          });
          dispatch({
            type: 'SET_SECTION_ID',
            id: 0,
          });
          dispatch(unloadingWizard());

          lpApp.mutex.setMutex('links', true);
        }

        // Executing All Conditions right after all data is set
        ConditionsEvo.execAllConditions();
      }
      dispatch(unloadingPricing());
      lpevents.trackGTMFunnel(window.location.pathname)
      callback()

      })
  }).catch((error) => {
    console.error('Error while loading contract',error)
  })
}



function fetchAndInitContract (contractPermalink, dispatch, getState) {
  // starting the loading phase
  dispatch({type: 'IS_LOADING'});
  dispatch(loadingWizard());
  dispatch(loadingPricing())
  getContract(contractPermalink)
  // Success of the request
    .then((response) => {
      const contract = response.data;
      lpApp.mutex.setMutex('links', false);
      // tell everyone that the document is not empty
      dispatch({type: 'NO_EMPTY'});
      // extract the preview indexes
      dispatch({
        type: 'PREVIEW_INDEX_',
        val: contract.views_wrapper,
      });
      lpApp.references.addViewsRefernce(contract.views_wrapper);
      if (contract.contract_architecture.params && contract.contract_architecture.params.varsExtraction) {
        lpApp.references.addSlackNotification(
          contract.contract_architecture.params.varsExtraction
        );
      }
      lpApp.references.addCustomizationsReference(contract.model_params);
      lpApp.setSubscription(contract.model_params.enable_subscription)
      lpApp.setIsPaidSession(contract.is_paid_session)
      lpApp.setType(contract.type, contract.contract_meta_id)
      lpApp.setContractMetaId(contract.contract_meta_id)
      .then(() => {
        if (contract.contract_uniqid) {
          lpApp.setContractUniqid(contract.contract_uniqid)
        }
        lpApp.setDisableIntro(contract.data_intro ? contract.data_intro === 'disabled' : false)
        if (contract.support_phone) {
          lpApp.setSupportPhone(contract.support_phone.txt)
        }
        // ======================================================
        // FIXME: construct a better one here
        lpApp.references.docs_wrappers = contract.docs_wrapper;

        // create the contract object
        dispatch({type: 'CREATE_CONTRACT',contract});

        // Initiating ConditionsEvo right after loading model
        ConditionsEvo.init();

        // Updating sections conditions after initiating ConditionsEvo
        updateSectionsIfConditions();

        // do initializatio  of static texts into the preview component
        // dispatch(initOutPut())
        if (
          contract.contract_architecture
          && contract.contract_architecture.params
          && contract.contract_architecture.params.fullWidth
        ) {
          dispatch(setFullWidth(contract.contract_architecture.params.fullWidth));
          lpApp.setFullWidth(contract.contract_architecture.params.fullWidth);
        } else {
          dispatch(setFullWidth(false));
          lpApp.setFullWidth(false);
        }

        if ((contract.contract_architecture.is_two_steps)) {
          // dispatch(setFullWidth(true))
          // lpApp.setFullWidth(true);
        } else if (contract.contract_architecture
            && contract.contract_architecture.params
            && contract.contract_architecture.params.fullWidth
        ) {
          dispatch(setFullWidth(contract.contract_architecture.params.fullWidth));
          lpApp.setFullWidth(contract.contract_architecture.params.fullWidth);
        } else {
          dispatch(setFullWidth(false));
          lpApp.setFullWidth(false);
        }

        // I don't know why I put this here wallah
        // dispatch({type: 'NO_EMPTY'});
        caluclateConditionDependecies();
        lpApp.indexes.updateDependencies();
        reorderViews(getState().views);
        // initialize the whole thing
        window.lp = {};
        for (let i = 0; i < getState().contract.total_sections; i += 1) window.lp[i] = false;
        // finish the loading phase
        lpExploreSections();

        // window.lp_grandpa = lpAllTree;
        lpApp.indexes.updateGrandpa(lpAllTree);
        // window.lp_var_gran = lpAllIndexVar;
        lpApp.indexes.grandpa_vars.buildGrandpaVariables(lpAllIndexVar);
        lpApp.references.addMandatpryOptions(lpApp.references.options);
        lpApp.references.addMandatoryVariables(lpApp.references.variables);

        window.addEventListener('beforeunload', autosave);

        // let url = new URL(window.location.href);
        const autosaveParam = (() => {
          // $_GET JS
          const $_GET_PARTS = window.location.search.substr(1).split('&');
          const $_GET = {};
          for (let i = 0; i < $_GET_PARTS.length; i += 1) {
            const temp = $_GET_PARTS[i].split('=');
            $_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
          }
          if ($_GET.autosaved) return true;
          return null;
        })();

        // Checking autosave
        const autosaveOVC = checkAutosave();

        if (window.contract_id !== '' || (lpApp.continuity && lpApp.continuity.continue)) {

          dispatch({
            type: 'SET_SECTION_ID',
            id: 0,
          });
          const currentEvent = {};
          currentEvent['Document version:'] = getState().contract.version;
          lpevents.register({
            Contract: getState().contract.name,
          });
          lpevents.track('Continue contract', currentEvent);
        } else if (!isNull(autosaveParam) && autosaveOVC !== false) {
          window.autosave = !!(autosaveOVC);

          // autosave check
          dispatch(autosaveLoadOVC(autosaveOVC.data));

          const sectionId = autosaveOVC.info.section - 1;

          dispatch({
            type: 'SET_SECTION_ID',
            id: sectionId,
          });

          lpApp.mutex.setMutex('links', true);
        } else {
          const currentEvent = {
            'LpApp': 'React'
          };
          currentEvent['Document version:'] = getState().contract.version;
          lpevents.register({
            Contract: getState().contract.name,
          });
          lpevents.track('Create new contract', currentEvent);
          dispatch({
            type: 'NOT_LOADING',
          });
          dispatch({
            type: 'SET_SECTION_ID',
            id: 0,
          });


          dispatch(unloadingWizard());

          lpApp.mutex.setMutex('links', true);
        }

        // Executing All Conditions right after all data is set
        ConditionsEvo.execAllConditions();
        dispatch(unloadingPricing());
        lpevents.trackGTMCheckoutStep(1, 'Questionnaire', getState().contract)
        // Load first funnel event
        lpevents.trackGTMFunnel(window.location.pathname)
        // set the current section to 0
      })
    })
    .catch((error) => {
      console.error(error)
      // the same thing, but with telling everyone what is the error
      lpApp.logs.log(error.name, error.message);
      dispatch(lpSetError(new LpError(0, 1, _lp('Problèmes de connexion, veuillez recharger la page'))));
    });

  lpExploreSections();
  // window.lp_grandpa = lpAllTree;
  lpApp.indexes.updateGrandpa(lpAllTree);
};

const getPricesAndFees = (checkoutInformations, prices, fees) =>  {
Object.keys(checkoutInformations).map((pack) => {
  prices[pack] = checkoutInformations[pack]
  fees[pack] = 0
  if (typeof checkoutInformations[pack] === 'object' && typeof checkoutInformations[pack].price !== 'undefined') {
    prices[pack] =  checkoutInformations[pack].price
    if (checkoutInformations[pack].fees && (checkoutInformations[pack].fees).length) {
      (checkoutInformations[pack].fees).forEach(feesElement => {
        fees[pack] += feesElement.price || 0
      });
    }
  }
})
}

function fetchAndInitCheckout(contractPermalink, uniqid, dispatch, getState) {
fetchAndInitContractWithOVC(contractPermalink, uniqid, dispatch, getState, () => {
// starting the loading phase
dispatch({type: 'IS_LOADING'});
dispatch(loadingWizard());
dispatch(loadingPricing())
getCheckout(contractPermalink, uniqid)
// Success of the request
  .then((response) => {
    const contract = response.data;
    if (contract.is_paid) {
      if (contract.redirectTo) window.location.href = contract.redirectTo
      else window.location.href = `/contrats/${contractPermalink}/continuer/${uniqid}/1`
    }
    if (contract.model_params)
      lpApp.setSubscription(contract.model_params.enable_subscription)
    lpApp.setIsPaidSession(contract.is_paid_session)
    lpApp.setType(contract.type, contract.contract_meta_id)
    if (contract.model_params)
      lpApp.references.addCustomizationsReference(contract.model_params);
    lpApp.setNewCustomer(contract.newCustomer)

    // create the contract object
    lpApp.setContractMetaId(contract.contract_meta_id)
    .then(() => {
      if (contract.contract_uniqid) {
        lpApp.setContractUniqid(uniqid)
      }
      if (contract && contract.checkoutInformations) {
        const showSubscribeOffer = lpApp.subscription || (!lpApp.paidSession && AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID.indexOf(lpApp.contractMetaId) > -1)
        if (contract.contract_architecture)
          dispatch({type: 'CREATE_CONTRACT', contract: contract});

        // prices
        const prices = {}
        const fees = {}

        getPricesAndFees(contract.checkoutInformations, prices, fees)

        if (showSubscribeOffer) { prices.second_price = 0.0; }
        //fees
        dispatch(buildCheckout(
          contract.user_id,
          uniqid,
          contract.contract_meta_id,
          prices,
          fees,
          'Conditional',
          contract.checkoutInformations
        ));
        lpApp.setPayed(contract.is_paid)
      }
      lpApp.setDisableIntro(contract.data_intro ? contract.data_intro === 'disabled' : false)
      if (contract.support_phone) {
        lpApp.setSupportPhone(contract.support_phone.txt)
      }
      // ======================================================
      // FIXME: construct a better one here
      lpApp.references.docs_wrappers = contract.docs_wrapper;
      lpApp.references.addCustomizationsReference(contract.model_params);

      dispatch(updateMailFromInput(contract.user_email));

      dispatch(unloadingPricing());
      lpApp.ops.slack.generateSendinBlue('Variable Extraction');

      // set the current section to 0
      lpevents.trackGTMFunnel(window.location.pathname)
    })

  })
  .catch((error) => {
    console.error(error)
    // the same thing, but with telling everyone what is the error
    lpApp.logs.log(error.name, error.message);
    dispatch(lpSetError(new LpError(0, 1, _lp('Problèmes de connexion, veuillez recharger la page'))));
  });

lpExploreSections();
// window.lp_grandpa = lpAllTree;
lpApp.indexes.updateGrandpa(lpAllTree);
  }, true)
};
// load condition dependecies
const dependeciesTable = {};


export function caluclateConditionDependecies() {
  if (lpApp.references.options) {
    const allKeys = Object.keys(lpApp.references.options);
    allKeys.forEach((idx) => {
      const now = lpApp.references.getOption(idx);
      // debugger;
      if (now.meta.conditional) {
        now.meta.conditions.forEach((jdx) => {
          if (idx.o) {
            if (typeof dependeciesTable[jdx.o] === 'undefined') {
              dependeciesTable[jdx.o] = [now.meta.id];
            } else {
              dependeciesTable[jdx.o].push(now.meta.id);
            }
          }
        });
      }
    });
  }
}


export function getMaa(v) {
  return lpAllTree[v];
}

export function getAndInitPrerender(uniqid) {
  return (dispatch, getState) => {

    let docIndex = '';

    if (typeof (lpApp.prerenderDoc) === 'number' && !Number.isNaN(lpApp.prerenderDoc)) docIndex = `&doc=${lpApp.prerenderDoc}`;

    const lnk = `/private_jsons/prerender/?${(typeof (uniqid) === 'string' && uniqid !== '') ? `for=${uniqid}` : ''}${docIndex}`;
    fetchAndInitContract(lnk, dispatch, getState)
  }
}

export function getAndInitContract(contractName, uniqid = null) {
  localStorage.setItem('URL_ENTREE', window.document.referrer)

  if (uniqid) {
    lpApp.setContractUniqid(uniqid)
    return (dispatch, getState) => {
      fetchAndInitContractWithOVC(contractName, uniqid, dispatch, getState)
    };
  }

  return (dispatch, getState) => {
    fetchAndInitContract(contractName, dispatch, getState)
  };
}

export function getAndInitCheckout(contractName, uniqid) {
  return (dispatch, getState) => {
    fetchAndInitCheckout(contractName, uniqid, dispatch, getState)
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/load_contract.js